<cdx-slotted-modal (close)="close()" [mobileFullHeight]="true" [showBack]="modalInHistory" (back)="goBack()">
	<h1 modal-header>
		Add a delivery address
	</h1>
	<fulfilment-add-delivery-address modal-content #addAddressForm (add)="close()" (formError)="handleError()"></fulfilment-add-delivery-address>
	<div modal-footer-primary>
		<button
			cdxButton
			i18n="@@existingAddress-addBtn"
			(click)="addAddressForm.addAddress()"
			[buttonState]="addAddressForm.buttonState"
			[disabled]="!addAddressForm.form?.canSubmit"
			data-cy="addAddressButton"
		>
			Add address
		</button>
		<cdx-notification
			iconName="alert"
			colour="warning"
			display="inline"
			content="Failed to add address, please try again later"
			[canShow]="showErrorNotification$ | async"
		>
		</cdx-notification>
	</div>
</cdx-slotted-modal>
